import React from 'react';
import logo from '../../assets/branding/HnB_Logo.jpeg';

type HnbLogoProps = {
  imageHeight?: number;
  rounded?: boolean;
  alt?: string;
  className?: string;
  style?: React.CSSProperties;
  showText?: boolean;
  title?: string;
  subtitle?: string;
  titleColor?: string;
  subtitleColor?: string;
};

const HnbLogo: React.FC<HnbLogoProps> = ({
  imageHeight = 80,
  rounded = true,
  alt = 'HnB Handsome & Beautiful',
  className,
  style,
  showText = true,
  title = 'Handsome & Beautiful (HnB)',
  subtitle = 'Beautify Yourself, Made Easy',
  titleColor = '#0f172a',
  subtitleColor = '#64748b',
}) => {
  return (
    <span
      className={className}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.85rem',
        ...style,
      }}
    >
      <img
        src={logo}
        alt={alt}
        style={{
          display: 'block',
          height: imageHeight,
          width: 'auto',
          maxWidth: '100%',
          objectFit: 'contain',
          borderRadius: rounded ? 18 : 0,
          flexShrink: 0,
        }}
      />

      {showText ? (
        <span
          style={{
            display: 'flex',
            flexDirection: 'column',
            lineHeight: 1.05,
          }}
        >
          <span
            style={{
              fontSize: '1.25rem',
              fontWeight: 800,
              letterSpacing: '-0.03em',
              color: titleColor,
              whiteSpace: 'nowrap',
            }}
          >
            {title}
          </span>

          <span
            style={{
              fontSize: '0.72rem',
              fontWeight: 600,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: subtitleColor,
              marginTop: '0.2rem',
              whiteSpace: 'nowrap',
            }}
          >
            {subtitle}
          </span>
        </span>
      ) : null}
    </span>
  );
};

export default HnbLogo;